import { useMemo } from 'react';

const matchesPath = (item, normalizedPath) => {
	if (!item.matchRoutes) return false;
	return item.matchRoutes.some((r) => normalizedPath === `/main/${String(r).toLowerCase()}`);
};

const findActiveTrail = (sections, normalizedPath, trail) => {
	for (const section of sections) {
		const currentTrail = [...trail, section.key];
		if (!section.children && matchesPath(section, normalizedPath)) {
			return currentTrail;
		}
		if (section.children) {
			const found = findActiveTrail(section.children, normalizedPath, currentTrail);
			if (found) return found;
		}
	}
	return null;
};

export const useActiveRoute = (sections, pathname) => {
	return useMemo(() => {
		const normalized = String(pathname || '').toLowerCase();
		const trail = findActiveTrail(sections, normalized, []);
		if (!trail) {
			return { activeItemKey: null, activeTrail: [], activeL1Key: null, activeL2Key: null };
		}
		return {
			activeItemKey: trail[trail.length - 1],
			activeTrail: trail,
			activeL1Key: trail[0] || null,
			activeL2Key: trail.length >= 2 ? trail[1] : null
		};
	}, [sections, pathname]);
};
